import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/*
 * @Author: mcdowell
 * @Date: 2021-08-18 18:30:54
 * @LastEditors: mcdowell
 * @LastEditTime: 2022-08-12 17:43:20
 */
import QRCode from 'qrcode';
// import util from '@utils/util';
import webLogin from '@utils/weblogin';
import commonService from '@services/commonService';
import { onelink } from '../data/index.js';

// import webRecharge from '@utils/webrecharge';
// import webConvertAndCash from '@utils/webConvertAndCash';

// 防抖 注意 接收的是一个 function 而不是 箭头函数 [ this 指向 修正 需要 ]
export var debounce = function debounce(callback, delay) {
  if (typeof callback !== 'function') {
    throw new TypeError('callback不是函数');
  }
  var timer = null;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (callback) {
        // eslint-disable-next-line no-invalid-this
        callback.apply(_this, args);
      }
    }, delay);
  };
};
export function GetQueryString(name) {
  if (name != undefined && name.trim().length) {
    name = name.trim();
  } else {
    name = undefined;
    return '';
  }
  var url = location.search || ''; // 获取url中"?"符后的字串
  var theRequest = {};
  if (url.indexOf('?') != -1) {
    var str = url.substr(1);
    var strParams = str.split('&');
    for (var i = 0; i < strParams.length; i++) {
      theRequest[strParams[i].split('=')[0].trim()] = decodeURIComponent(strParams[i].split('=')[1]);
    }
  }
  if (name != undefined) {
    return theRequest[name] != undefined ? theRequest[name] : null;
  }
  return theRequest;
}
// 生成二维码
export var createQRCode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(str, callback) {
    var image;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return QRCode.toDataURL(str, {
            errorCorrectionLevel: 'H',
            quality: 0.3,
            margin: 0,
            color: {
              dark: '#333'
            }
          });
        case 2:
          image = _context.sent;
          callback && callback(image);
          return _context.abrupt("return", image);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createQRCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var compoundUrl = function compoundUrl(pathname, hasLang) {
  var json = {
    pathname: pathname
  };
  if (hasLang) {
    var local = getI18nLocale();
    local = pathname == '/' ? '' : local;
    // 带参传递
    json = {
      pathname: "/".concat(local).concat(pathname == '/' ? '' : pathname),
      search: {}
    };
  }
  // 跳转链接参数透传
  return directToPath(json, true);
};

// 通过 url 参数获取来源
export var getQueryFrom = function getQueryFrom() {
  // 获取来源 参数 事例
  // ?utm_source=google%2B&utm_medium=video&utm_campaign=1
  var source = GetQueryString('utm_source');
  var medium = GetQueryString('utm_medium');
  var campaign = GetQueryString('utm_campaign');
  return source || medium || campaign ? "".concat(source, "_").concat(medium, "_").concat(campaign) : '';
};
export var getQueryFromJson = function getQueryFromJson() {
  // 获取来源 参数 事例
  // ?utm_source=google%2B&utm_medium=video&utm_campaign=1
  var source = GetQueryString('utm_source');
  var medium = GetQueryString('utm_medium');
  var campaign = GetQueryString('utm_campaign');
  return {
    sourceName: source || '',
    mediumName: medium || campaign ? "".concat(medium, "_").concat(campaign) : ''
  };
};
export var getFullOnelink = function getFullOnelink() {
  // 获取来源
  var queryFrom = getQueryFromJson();
  console.log(queryFrom, '流量来源');
  return "".concat(onelink, "?pid=").concat(queryFrom.sourceName, "&c=").concat(queryFrom.mediumName);
};

// 改写 原 @utils/webrecharge 充值 doRecharge 方法
// 为了神策 充值来源 数据上报
export function doRecharge(params) {
  KEWLSensorTrack({
    lmweb_clickText: '跳转',
    lmweb_tabName: 'doRecharge'
  });
  var queryFrom = getQueryFrom();
  var fromStr = queryFrom ? "pc_".concat(queryFrom) : 'pc';
  var userInfo = webLogin.getUserInfoData();
  var href = '';
  if (window.bridge && window.bridge.webRecharge) {
    href = window.bridge.webRecharge.doRecharge(userInfo);
    if (href) {
      var hasQuery = href.indexOf('?') > -1;
      window.location.href = "".concat(href).concat(hasQuery ? '&' : '?', "from=").concat(fromStr);
      return;
    }
  }

  // TODO: - 工程都改版完，以下代码可以删除
  if (webLogin.checkLogin()) {
    userInfo = webLogin.getUserInfoData();
    var _userInfo = userInfo,
      deviceid = _userInfo.deviceid;
    var u_country = userInfo.user.country.toUpperCase();
    var area = userInfo.user.area.toUpperCase();
    /*
     *@desc  不同地区的用户登录后使用不同的充值方式
     */

    var cuHost = location.host == 'www.lmlite.net' ? 'www.royallive.com' : location.host;

    // 优先按照国家码判断用户，若用户是ID、IN国家的，直接下发idpay或inpay
    switch (u_country) {
      case 'JP':
        // 日本使用自己的充值
        window.location.href = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/jppay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        return;
      case 'IN':
        // 日本使用自己的充值
        window.location.href = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/inpay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        return;
      case 'ID':
        window.location.href = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/idpay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        return;
    }

    // A_CT A_JP  A_US A_ID A_DE A_IN A_VN A_AR A_BR A_GB
    switch (area) {
      case 'A_VN':
        window.location = "".concat(location.protocol, "//").concat(cuHost, "/app/pay/vietnam.html?thirdchannel=6&uid=").concat(userInfo.user.uid, "&token=").concat(userInfo.token, "&deviceid=").concat(deviceid, "&from=").concat(fromStr);
        break;
      case 'A_CT':
        window.location = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/twpay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        break;
      case 'A_ID':
        // window.location = location.protocol + '//' + location.host + '/app/pay/index.html?thirdchannel=6&type=32&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
        // window.location = location.protocol + '//' + location.host + '/app/pay/idpaychange.html?from=pc&thirdchannel=6&type=32&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
        window.location = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/idpay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        break;
      case 'A_IN':
        window.location = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/inpay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        // window.location = location.protocol + '//' + location.host + '/app/newpay/dist/inpay.html?pay_source=101&from=pc&thirdchannel=6&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
        break;
      case 'A_AR':
        window.location = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/sapay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        break;
      case 'A_US':
        window.location = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/uspay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        break;
      default:
        window.location.href = "".concat(location.protocol, "//").concat(cuHost, "/app/livemepay/dist/uspay.html?pay_source=101&thirdchannel=6&from=").concat(fromStr);
        break;
    }
  } else {
    window.location.href = "/app/livemepay/dist/uspay.html?from=".concat(fromStr);
  }
}
export function doConvert(params) {
  KEWLSensorTrack({
    lmweb_clickText: '跳转',
    lmweb_tabName: 'doConvert'
  });
  var queryFrom = getQueryFrom();
  var fromStr = queryFrom ? "pc_".concat(queryFrom) : 'pc';
  var userInfo = webLogin.getUserInfoData();
  var href = '';
  if (window.bridge && window.bridge.webConvertAndCash) {
    href = window.bridge.webConvertAndCash.doConvert(userInfo);
    if (href) {
      var hasQuery = href.indexOf('?') > -1;
      window.location.href = "".concat(href).concat(hasQuery ? '&' : '?', "from=").concat(fromStr);
      return;
    }
  }

  // TODO: - 工程都改版完，以下代码可以删除
  if (webLogin.checkLogin()) {
    window.location.href = "".concat(location.protocol, "//").concat(location.host, "/app/withdraw/?thirdchannel=6&h5=1&from=").concat(fromStr, "#/");
  } else {
    window.location.href = "/app/neww/dist/index.html?from=".concat(fromStr, "#/");
  }
}
export function doCashOut(params) {
  KEWLSensorTrack({
    lmweb_clickText: '跳转',
    lmweb_tabName: 'doCashOut'
  });
  var queryFrom = getQueryFrom();
  var fromStr = queryFrom ? "pc_".concat(queryFrom) : 'pc';
  var userInfo = webLogin.getUserInfoData();
  var href = '';
  if (window.bridge && window.bridge.webConvertAndCash) {
    href = window.bridge.webConvertAndCash.doCashOut(userInfo);
    if (href) {
      var hasQuery = href.indexOf('?') > -1;
      window.location.href = "".concat(href).concat(hasQuery ? '&' : '?', "from=").concat(fromStr);
      return;
    }
  }

  // TODO: - 工程都改版完，以下代码可以删除
  if (webLogin.checkLogin()) {
    window.location.href = "".concat(location.protocol, "//").concat(location.host, "/app/withdraw/?thirdchannel=6&h5=1&from=").concat(fromStr, "#/");
  } else {
    window.location.href = "/app/neww/dist/index.html?from=".concat(fromStr, "#/");
  }
}

/**
     * 神策 上报
     * lmweb_clickText:用户的点击操作对应的文案 如果是直播列表上报vid,用户头像上报UID
     * 重点：趋势，充值，提现，登录，注册，获取验证码，分类tab,follow,送礼，发送消息，直播列表点击"
     * tabName:分类
     * giftId:礼物ID
     * giftId:礼物价格
     */
export function KEWLSensorTrack(params) {
  var defaultParams = {
    lmweb_clickText: '',
    lmweb_tabName: '',
    lmweb_giftId: '',
    lmweb_giftPriceLong: 0,
    lmweb_LiveUid: '',
    // 直播间Uid
    lmweb_LiveVid: '' // 直播间Vid
  };
  var KEWLSensorParams = Object.assign(defaultParams, params);
  if (typeof KEWLSensor !== 'undefined') {
    window.KEWLSensor.register('kewlweb_Imsite', defaultParams);
    window.KEWLSensor.track(KEWLSensorParams);
  }
}
export function isMobile() {
  var UA = window.navigator.userAgent || '';
  var IsAndroid = /Android|HTC/i.test(UA);
  var IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
  return IsAndroid || IsIPhone;
}
export function getI18nCountryCode(_x3) {
  return _getI18nCountryCode.apply(this, arguments);
}
function _getI18nCountryCode() {
  _getI18nCountryCode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(countryCode) {
    var user, cc;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // if(window.$i18n){
          //     return (await window.$i18n.countryCode ? window.$i18n.countryCode : "us").toLowerCase();
          // }else{
          // if (countryCode) {
          //     return countryCode.toLowerCase();
          // } else {
          user = webLogin.getUserInfo();
          if (!user) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", user.country ? user.country.toLowerCase() : 'us');
        case 3:
          cc = localStorage.getItem('countryCode');
          if (!cc) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", cc.toLowerCase());
        case 6:
          _context2.next = 8;
          return getCountryCodeByIp();
        case 8:
          return _context2.abrupt("return", _context2.sent.toLowerCase());
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getI18nCountryCode.apply(this, arguments);
}
export function getCountryCodeByIp() {
  return _getCountryCodeByIp.apply(this, arguments);
}
function _getCountryCodeByIp() {
  _getCountryCodeByIp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var data, countryCode;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return commonService.createApi().getCountryCodeByIp();
        case 3:
          data = _context3.sent;
          if (!data) {
            _context3.next = 8;
            break;
          }
          countryCode = data.countryCode;
          localStorage.setItem('countryCode', countryCode);
          return _context3.abrupt("return", countryCode);
        case 8:
          _context3.next = 13;
          break;
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", 'US');
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 10]]);
  }));
  return _getCountryCodeByIp.apply(this, arguments);
}
export function directToPath(json) {
  var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var getSearchData = (window.location.search.match(/^\?+/) ? getQueryData(window.location.search) : {}) || '';
  var removeData = toString.call(json.remove) === '[object Array]' ? json.remove : [];
  for (var i = 0; i < removeData.length; i++) {
    delete getSearchData[removeData[i]];
  }
  if (getSearchData.short) {
    // getSearchData.short = '';
    delete getSearchData.short;
  }
  var searchObj = _objectSpread(_objectSpread({}, getSearchData), json.search || {});
  var searchStr = Object.keys(searchObj).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(searchObj[key]));
  }).join('&');
  searchStr = Object.keys(searchObj).length === 0 ? searchStr : "?".concat(searchStr);
  var protocol = window.location.protocol || ''; // http:
  var origin = json.origin || "".concat(protocol, "//").concat(window.location.host) || ''; // 不带/
  var pathname = json.pathname || window.location.pathname || ''; // 需要带/
  if (!isInit) {
    // 初始化url不上报
    KEWLSensorTrack({
      lmweb_clickText: '跳转',
      lmweb_tabName: pathname
    });
  }
  return origin + pathname + searchStr;
}
export function getQueryData(queryString) {
  queryString = queryString.replace(/^\?+/, '').replace(/&amp;/, '&');
  var querys = queryString.split('&');
  var i = querys.length;
  var _URLParms = {};
  while (i--) {
    var item = querys[i].split('=');
    if (item[0]) {
      var value = item[1] || '';
      try {
        value = decodeURIComponent(value);
      } catch (e) {
        value = unescape(value);
      }
      _URLParms[decodeURIComponent(item[0])] = value;
    }
  }
  return _URLParms;
}
export function getI18nLocale() {
  if (window.$i18n) {
    return window.$i18n.urlLang ? window.$i18n.urlLang : 'en';
  }
  return window.store ? window.store.state.locale : 'en';
}
export function downloadFile(src) {
  var $a = document.createElement('a');
  $a.setAttribute('href', src);
  $a.setAttribute('download', '');
  $a.setAttribute('target', '_bank');
  var event = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });
  $a.dispatchEvent(event);
}

/**
* jsonp获取请求数据
* @param {string}url
* @param {object}params
* @param {function}callback
*/
export function jsonp(_ref2) {
  var url = _ref2.url,
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? {} : _ref2$params,
    _ref2$callback = _ref2.callback,
    callback = _ref2$callback === void 0 ? 'callback' : _ref2$callback;
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    params = JSON.parse(JSON.stringify(params));
    var arrs = [];
    for (var key in params) {
      arrs.push("".concat(key, "=").concat(params[key]));
    }
    arrs.push("callback=".concat(callback));
    script.src = "".concat(url, "?").concat(arrs.join('&'));
    try {
      document.body.appendChild(script);
    } catch (error) {
      console.info(error);
    }
    window[callback] = function (data) {
      resolve(data);
      document.body.removeChild(script);
    };
  });
}